import { createElement } from 'rlink-react';

import scrollToSection from 'helpers/scrolling/scrollToSection';

const onBackTopClick = function (e) {
  e.preventDefault();
  window.hashTrack = true;
  scrollToSection('#master', true, false, 3);
};

export default function BackToTopButton () {
  return (
    <div onClick={e => onBackTopClick(e)} id="back-top">
      <a href="#">
        <span>back top</span>
      </a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/buttons/BackToTopButton.jsx